export default "__VITE_ASSET__ce1cd8d9__"